<script setup>
import {defineProps} from "vue";
defineProps({
  legend: String,
  class: String,
  toggleable: Boolean
})
</script>

<template>
<slot></slot>
</template>

<style scoped lang="scss">

</style>
